import * as Yup from 'yup'

import required from '@galo-monitor/forms/validators/required.validator'

const planSchema = ({ t }) => Yup.object().shape({
  name: required({ t })(Yup.string()),
  modules_farms: Yup.array().of(
    Yup.object().shape({ id: Yup.number() })
  ).nullable()
})

export default planSchema
